import Vue from 'vue'
import Router from 'vue-router'
import RouterGuard from "./router-guard"

Vue.use(Router)

import Home from './components/Home.vue'

export default new Router({
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: RouterGuard
    },
    {
        path: '/relacaoleitos',
        name: 'relacaoleitos',
        component: () => import('./components/relatorios/relacaoLeitos/relacaoLeitos.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/ocupacaomeianoite',
        name: 'ocupacaomeianoite',
        component: () => import('./components/relatorios/ocupacao-meia-noite/OcupacaoMeiaNoite.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/pacientesinternados',
        name: 'pacientesinternados',
        component: () => import('./components/relatorios/pacientesInternados/PacientesInternados.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/historicointernacoes',
        name: 'historicointernacoes',
        component: () => import('./components/relatorios/historico-internacoes/HistoricoInternacoes.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/historicomovimentacao',
        name: 'historicomovimentacao',
        component: () => import('./components/relatorios/historico-movimentacao/HistoricoMovimentacao.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/relatoriolongapermanencia',
        name: 'relatoriolongapermanencia',
        component: () => import('./components/relatorios/longa-permanencia/LongaPermanencia.vue'),
        beforeEnter: RouterGuard
    },
    {
        path: '/relatoriolistageminternacoes',
        name: 'relatorioListagemInternacoes',
        component: () => import('./components/relatorios/listagem-internacoes/ListagemInternacoes.vue'),
        beforeEnter: RouterGuard
    },
  ]
})
